/**
 * UGC videos — one-at-a-time testimonial slider with custom video controls.
 * Click to play/pause, mute toggle, progress bar; prev/next arrows move one
 * slide at a time. Videos pause when scrolled out of view.
 */
(function () {
  "use strict";

  document.querySelectorAll(".ugc__card--video").forEach(function (card) {
    var video = card.querySelector(".ugc__video");
    if (!video) return;
    var progress = card.querySelector("[data-ugc-progress]");
    var muteBtn = card.querySelector("[data-ugc-mute]");

    function sync() {
      card.classList.toggle("is-playing", !video.paused && !video.ended);
      card.classList.toggle("is-muted", video.muted);
    }
    video.addEventListener("play", sync);
    video.addEventListener("pause", sync);
    video.addEventListener("volumechange", sync);
    sync();

    card.addEventListener("click", function (e) {
      if (e.target.closest("[data-ugc-mute]")) return;
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });

    if (muteBtn) {
      muteBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        if (!video.muted && video.volume === 0) video.volume = 1;
      });
    }

    if (progress) {
      video.addEventListener("timeupdate", function () {
        var pct = video.duration ? (video.currentTime / video.duration) * 100 : 0;
        progress.style.width = pct + "%";
      });
    }
  });

  // Slider arrows — one full slide per click.
  document.querySelectorAll("[data-ugc-viewport]").forEach(function (viewport) {
    var track = viewport.querySelector("[data-ugc-track]");
    var prev = viewport.querySelector("[data-ugc-prev]");
    var next = viewport.querySelector("[data-ugc-next]");
    if (!track || !prev || !next) return;

    function step() {
      var slide = track.querySelector(".ugc__slide");
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 20;
      return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    function update() {
      var fits = track.scrollWidth <= track.clientWidth + 2;
      viewport.classList.toggle("ugc__viewport--fits", fits);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", function () {
      window.requestAnimationFrame(update);
    });
    window.addEventListener("resize", update);
    window.addEventListener("load", update);
    update();
  });

  // Pause a video when its slide scrolls out of view; autoplay in view.
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector(".ugc__video");
          if (!v) return;
          if (en.isIntersecting) {
            if (v.getAttribute("data-ugc-autoplay") === "true") v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    document.querySelectorAll(".ugc__slide").forEach(function (s) {
      io.observe(s);
    });
  }
})();
